import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { ITEM_SUMMARY_CARD_BASE_CLASSNAME } from './Constants';
import { createItemSummaryCard } from './ItemSummaryCard';
createComponents(".".concat(ITEM_SUMMARY_CARD_BASE_CLASSNAME), createItemSummaryCard, NO_PATTERN_BUSINESS_LOGIC);
